import Analytics from '@withlocals/withlocals-analytics';
import { Translator } from 'Translator';
import classnames from 'classnames';
import HeartFilled from 'components/icons/HeartFilled';
import HeartOpen from 'components/icons/HeartOpen';
import useFavoritesItem from 'hooks/useFavoriteItem';
import React from 'react';

const CSS = require('./FavoritesButton.less');

interface FavoritesButtonProps {
  experienceId: string;
  analyticsCategory: string;
  className?: string;
}

function FavoritesButton({
  experienceId,
  analyticsCategory,
  className,
}: FavoritesButtonProps) {
  const { isFavorite, setAsFavorite } = useFavoritesItem(experienceId);

  const toggleActive = () => {
    Analytics.track(
      analyticsCategory,
      !isFavorite ? 'Add to Favorites' : 'Remove from Favorites',
      experienceId,
    );
    setAsFavorite(!isFavorite);
  };

  const label = !isFavorite
    ? Translator.translate(
        'Common.Labels.favoritesAdd',
        {},
        true,
        'Add to favorites',
      )
    : Translator.translate(
        'Common.Labels.favoritesRemove',
        {},
        true,
        'Remove from favorites',
      );

  return (
    <button
      className={classnames(CSS.FavoritesButton, { [className]: className })}
      onClick={toggleActive}
      aria-label={label}
    >
      {isFavorite ? (
        <HeartFilled
          width={24}
          height={22}
          className={classnames(CSS.HeartFilled, CSS.Heart)}
        />
      ) : (
        <>
          <HeartOpen width={24} height={22} className={CSS.Heart} />
          <HeartFilled width={22} height={20} className={CSS.HeartBackground} />
        </>
      )}
    </button>
  );
}

export default FavoritesButton;
